import { Injectable } from '@angular/core';
import {
    CompanySettings,
    CompanySettingsUpdate
} from '../../core-data-model/CompanySettings.model';
import { CompanySettingsServer } from '../../core-data-model/CompanySettingsApi.serverinterface';
import { TranslationService } from '../../translations';

@Injectable({ providedIn: 'root' })
export class CompanySettingsApiTransformer {
    constructor(private TR: TranslationService) {}

    transformServerToClient(server: CompanySettingsServer): CompanySettings {
        const companySettingsClient = new CompanySettings({
            companyId: server.companyId,
            companyName: server.companyName,
            allowPiReports: server.allowPIReports,
            allowProReports: server.allowPROReports,
            piSessionExpirationDays: server.piSessionExpirationDays,
            proSessionExpirationDays: server.proSessionExpirationDays,
            allowPowerUserCreateTopLevelFolders:
                server.allowPowerUserCreateTopLevelFolders,
            timeZone: server.timeZone,
            languageLocale: server.languageLocale,
            isOptionalResearchQuestionShown:
                server.isOptionalResearchQuestionsShown,
            hasApiAccess: server.hasApiAccess,
            hasCognitiveJAAccess: server.hasCognitiveJAAccess,
            oiAssessmentStatusWebhookUrl: server.oiAssessmentStatusWebHookUrl,
            employeeCount: server.employeeCount,
            isBehavioralConsentNeeded: server.isBehavioralConsentNeeded,
            includeCogSampleLink: server.includeCogSampleLink,
            consentText: server.consentText,
            isMfaEnabled: server.isMfaEnabled,
            disableAiInterviewFeedbackSummary:
                server.disableAiInterviewFeedbackSummary
        });
        return companySettingsClient;
    }

    transformClientToServer(
        client: CompanySettingsUpdate
    ): CompanySettingsServer {
        const companySettingsServer = {
            allowPIReports: client.allowPiReports,
            allowPROReports: client.allowProReports,
            piSessionExpirationDays: client.piSessionExpirationDays,
            proSessionExpirationDays: client.proSessionExpirationDays,
            allowPowerUserCreateTopLevelFolders:
                client.allowPowerUserCreateTopLevelFolders,
            timeZone: client.timeZone,
            languageLocale: client.languageLocale,
            isOptionalResearchQuestionsShown:
                client.isOptionalResearchQuestionShown,
            hasApiAccess: client.hasApiAccess,
            hasCognitiveJAAccess: client.hasCognitiveJAAccess,
            oiAssessmentStatusWebHookUrl: client.oiAssessmentStatusWebhookUrl,
            employeeCount: client.employeeCount,
            isBehavioralConsentNeeded: client.isBehavioralConsentNeeded,
            includeCogSampleLink: client.includeCogSampleLink,
            consentText: client.consentText
        };
        return companySettingsServer;
    }
}
